class jfCustomLicense {
    constructor($timeout, xrayLicensesDao, CompLicensesDao, WebhooksDao, JFrogNotifications, XRayUtils, JFrogEventBus,
                XRayUIState, $window, $scope) {
        this.jFrogNotifications = JFrogNotifications;
        this.CompLicensesDao = CompLicensesDao;
        this.XRayUIState = XRayUIState;
        this.webhooksDao = WebhooksDao;
        this.$scope = $scope
        this.$window = $window;
        this.$timeout = $timeout;
        this.xrayUtils = XRayUtils;
        this.xrayLicensesDao = xrayLicensesDao;
        this.jfrogEventBus = JFrogEventBus;

        this.EVENTS = JFrogEventBus.getEventsDefinition();


    }

    $onInit() {
        if (this.viewType == 'view') {
            this.isDisabled = true;
        }
        this._getLicensesList();
    }

    openInternalBrowser(href) {

        let x = screen.width / 2 - 700 / 2 + this.findLeftWindowBoundry();
        let y = screen.height / 2 - 450 / 2 + this.findTopWindowBoundry();
        this.$window.open(href, 'XRAY', 'height=685,width=900,left=' + x + ',top=' + y);
        return false;

    }


    findLeftWindowBoundry() {
        // In Internet Explorer window.screenLeft is the window's left boundry
        if (this.$window.screenLeft) {
            return this.$window.screenLeft;
        }

        // In Firefox window.screenX is the window's left boundry
        if (this.$window.screenX) {
            return this.$window.screenX;
        }

        return 0;
    }

    // Find Left Boundry of current Window
    findTopWindowBoundry() {
        // In Internet Explorer window.screenLeft is the window's left boundry
        if (this.$window.screenTop) {
            return this.$window.screenTop;
        }

        // In Firefox window.screenY is the window's left boundry
        if (this.$window.screenY) {
            return this.$window.screenY;
        }

        return 0;
    }


    save() {
        let keyType = "component"
        let daoKey = 'setLicense';
        if (_.isArray(this.compDetails)) {
            keyType = "components"
            daoKey = 'setBulkLicenses';
        }

        let payload = {license: this.selectedLicense};
        payload[keyType] = this.compDetails
        console.log('daoKey is', daoKey);
        this.CompLicensesDao[daoKey](payload).$promise.then(() => {
            this.jFrogNotifications.create({info: 'Manual Impact Analysis Started'});
            this.$timeout(() => {
                this.jfrogEventBus.dispatch(this.EVENTS.COMPONENT_VERSION_SELECTED);
            }, 500);
            //this.jfrogEventBus.dispatch(EVENTS.CUSTOM_LICENSE_ASSIGNED,);
            this.compDetails.newAssignedLicense = _.cloneDeep(this.selectedLicense)

            this.$close();
        });
    }

    _getLicensesList() {
        this.xrayLicensesDao.getNames().$promise.then((licenses) => {
            licenses.shift();
            this.constLicenseList = _.cloneDeep(licenses);
            if (this.viewType == 'view') {
                this.selectedLicense = _.find(this.constLicenseList, {name: this.compDetails});
            }
        });
    }
}

export function jfCustomLicense() {

    return {
        restrict: 'E',
        scope: {
            componentId: '@?',
            propagatedLicense: '=?',
            compDetails: '=?',
            viewType: '=?',
            $dismiss: '&',
            $close: '&'
        },
        controller: jfCustomLicense,
        controllerAs: 'jfCustomLicense',
        templateUrl: 'directives/jf_custom_license/jf_custom_license.html',
        bindToController: true
    };
}



// WEBPACK FOOTER //
// ./modules/xray/directives/jf_custom_license/jf_custom_license.js